import React from "react";
import { Button, useNotify, useRefresh, useTranslate } from "react-admin";

import { httpClient } from "../../../api/httpClient";
import { formatDateTimeString } from "../../_helpers/dateTime";
import { useSimpleModalToggle } from "../../dialogs/useSimpleModal";
import { useGridUserDataGlobalFiltersContext } from "../../../contexts/GridUserDataGlobalFiltersProvider";
import { useNotifyError } from "../../../utils/notifiers/useNotifyError";
import { useNotifySuccess } from "../../../utils/notifiers/useNotifySuccess";
import { StorageTransactionDialog } from "../shared/StorageTransactionDialog";
import { MovementForm } from "./MovementForm";
import { MovementResults } from "./MovementResults";
import { useStyles } from "./styles";

export const MovementsButton = () => {
	const translate = useTranslate();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const notifySuccess = useNotifySuccess();
	const refresh = useRefresh();
	const classes = useStyles();
	const { open, handleOpen, handleClose } = useSimpleModalToggle();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const [loading, setLoading] = React.useState(false);
	const [movementResults, setMovementResults] = React.useState([]);
	const [lastTaskId, setLastTaskId] = React.useState(null);

	const terminalId = Array.isArray(globalFilters?.terminal_id)
		? globalFilters.terminal_id[0]
		: globalFilters?.terminal_id;

	React.useEffect(() => {
		if (!terminalId) {
			handleClose();
		}
	}, [terminalId, handleClose]);

	const handleOnSubmit = (values) => {
		if (!values.from_place_id || !values.to_place_id || !values.task_id) {
			notify(translate("osfc.messages.unsuccess"), { type: "warning" });
			return;
		}

		setLastTaskId(values.task_id);
		setLoading(true);
		httpClient("storage-transactions-movements", {
			method: "POST",
			body: JSON.stringify({
				from_place_id: values.from_place_id,
				to_place_id: values.to_place_id,
				pallet_ids: values.pallet_ids,
				task_id: values.task_id,
			}),
		})
			.then((response) => {
				notifySuccess(translate("osfc.messages.success"));
				const newResult = {
					...response.json,
					timestamp: formatDateTimeString(new Date()),
				};
				setMovementResults((prev) => [newResult, ...prev]);
				refresh();
			})
			.catch((error) => {
				notifyError(error);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const handleDialogClose = () => {
		setMovementResults([]);
		setLastTaskId(null);
		handleClose();
	};

	return (
		<React.Fragment>
			<Button label="resources.storage-transactions.actions.move_pallet" onClick={handleOpen} />
			<StorageTransactionDialog
				open={open}
				onClose={handleDialogClose}
				title={translate("resources.storage-transactions.actions.move_pallet")}
				loading={loading}
				classes={classes}
				form={
					<MovementForm
						onSubmit={handleOnSubmit}
						onCancel={handleDialogClose}
						loading={loading}
						terminalId={terminalId}
						classes={classes}
						lastTaskId={lastTaskId}
					/>
				}
				results={<MovementResults results={movementResults} classes={classes} />}
			/>
		</React.Fragment>
	);
};
